'use strict';

/* globals config */

require([config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/vue.js'], function (Vue) {
	Vue.component('board-menu', {
		props: ['saveBoard', 'renameBoard', 'removeBoard', 'isBoardOwner'],
		methods: {
			addNote: function (noteComponent) {
				this.$root.$emit('addNote', noteComponent);
			},
		},
		data: function () {
			return {
				menuItems: [
					{ icon: 'fa fa-font', name: 'Text', component: 'text-note' },
					{ icon: 'fa fa-picture-o', name: 'Image', component: 'image-note' },
					{ icon: 'fa fa-video-camera', name: 'Video', component: 'video-note' },
					{ icon: 'fa fa-cloud-upload', name: 'Upload', component: 'upload-note' },
				],
			};
		},
		template: '<div class="ib-menu"><ul>' +
		'<li v-for="item in menuItems"><button v-on:click="addNote(item.component)"><i :class="item.icon" aria-hidden="true"></i> {{item.name}}</button></li>' +
		'<li><button v-on:click="saveBoard()"><i class="fa fa-floppy-o" aria-hidden="true"></i> Export</button></li>' +
		'<li v-if="isBoardOwner"><button v-on:click="renameBoard()"><i class="fa fa-pencil-square" aria-hidden="true"></i> Rename</button></li>' +
		'<li v-if="isBoardOwner"><button v-on:click="removeBoard()"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button></li>' +
		'</ul></div>',
	});
});
